import { type PimProductV1Flags } from '@redteclab/api/clients/bully'

import { TENANT } from '../../../tenant'
import { PRODUCT_TEMPLATES } from '../productTemplates'

const TENANTS_WITH_RX = new Set([TENANT.CH, TENANT.COM])
const TENANTS_WITH_OTX = new Set([TENANT.COM])

/**
 * Determines and returns the product template to use for a product with the given props
 * @param params paramter object
 * @param params.flags product flags (from product object)
 * @param params.tenant shop tenant prop (from product object)
 */
export const productAccessorGetProductTemplate = ({
  flags,
  tenant,
}: {
  flags: PimProductV1Flags | undefined
  tenant: TENANT
}): PRODUCT_TEMPLATES => {
  switch (true) {
    case flags?.prescription_medicine.active: {
      return TENANTS_WITH_RX.has(tenant)
        ? PRODUCT_TEMPLATES.RX
        : PRODUCT_TEMPLATES.OTC
    }
    case flags?.medicament.active: {
      return TENANTS_WITH_OTX.has(tenant)
        ? PRODUCT_TEMPLATES.OTX
        : PRODUCT_TEMPLATES.OTC
    }
    default: {
      return PRODUCT_TEMPLATES.OTC
    }
  }
}
